export const Stylesilla = {
  asientos: { margin: '0.7px', height: '15px', width: '15px', borderRadius: '5px' },
  mesas: {
    height: '35px', width: '45px', borderRadius: '5px',
    alignItems: 'center', justifyContent: 'center', margin: '0.5px'
  }
}